// Hostname oficial del frontend en producción (backend madrmbt, nginx /opt/rmbt/html).
// El resto de hostnames (pre, local, previews de Jenkins) se consideran entornos
// donde se pueden mostrar rutas ocultas (/_admin/*, /_preview/*) sin exponerlas
// al público final.
const PRODUCTION_HOST = "calidadtelecos.cnmc.gob.es";

export function isProductionHost() {
  if (typeof window === "undefined") return false;
  return window.location.hostname === PRODUCTION_HOST;
}
